import "../../css/card.css";
const Card = () => {
   return (
      <>
         <div className="section animated fadeIn">
            <div className="row">
               {/* ATENCIÓN AL CLIENTE */}
               <div className="col s12 m6 l3 x3">
                  <div className="card card-home-info card-img-atencion-cliente z-depth-1 hoverable">
                     <div className="card-content opacity white-text center-align">
                        <i className="material-icons light-blue-text text-accent-2" style={{ fontSize: '2.2rem', marginBottom: '8px' }}>
                           headset_mic
                        </i>
                        <span className="card-home-label">
                           ATENCIÓN AL CLIENTE
                        </span>
                        <h5 className="card-home-number">
                           0800-199-0023
                        </h5>
                     </div>
                  </div>
               </div>

               {/* CENTROS DE ATENCIÓN */}
               <div className="col s12 m6 l3 x3">
                  <div className="card card-home-info card-img-centro-atencion z-depth-1 hoverable">
                     <div className="card-content opacity white-text center-align">
                        <i className="material-icons light-blue-text text-accent-2" style={{ fontSize: '2.2rem', marginBottom: '8px' }}>
                           location_on
                        </i>
                        <span className="card-home-label">
                           CENTROS DE ATENCIÓN
                        </span>
                        <h5 className="card-home-number">
                           JUJUY y SALTA
                        </h5>
                     </div>
                  </div>
               </div>

               {/* DENUNCIA DE ACCIDENTES DE TRABAJO */}
               <div className="col s12 m6 l3 x3">
                  <div className="card card-home-info card-img-denuncia z-depth-1 hoverable">
                     <div className="card-content opacity white-text center-align">
                        <i className="material-icons light-blue-text text-accent-2" style={{ fontSize: '2.2rem', marginBottom: '8px' }}>
                           local_hospital
                        </i>
                        <span className="card-home-label">
                           DENUNCIA DE ACCIDENTES DE TRABAJO
                        </span>
                        <h5 className="card-home-number">
                           0800-199-0022
                        </h5>
                     </div>
                  </div>
               </div>

               {/* DENUNCIA DE ACCIDENTES DE AUTOS */}
               <div className="col s12 m6 l3 x3">
                  <div className="card card-home-info card-img-automotor z-depth-1 hoverable">
                     <div className="card-content opacity white-text center-align">
                        <i className="material-icons light-blue-text text-accent-2" style={{ fontSize: '2.2rem', marginBottom: '8px' }}>
                           directions_car
                        </i>
                        <span className="card-home-label">
                           DENUNCIA DE ACCIDENTES DE AUTOS
                        </span>
                        <h5 className="card-home-number" style={{ fontSize: '1.15rem', lineHeight: '1.4' }}>
                           (388) 517-4304 <br/> (388) 685-9269
                        </h5>
                     </div>
                  </div>
               </div>

            </div>
         </div>
      </>
   )
}

export default Card